import { useTranslation } from "react-i18next";
import { usePdfPages } from "./usePdfPages";

export const PdfView = ({ url, title }) => {
  const { t } = useTranslation();
  const { pages, error } = usePdfPages(url);

  if (error) return <p className="px-6 text-center text-sm text-white/80" data-testid="doc-viewer-error">{t("errors.generic")}</p>;
  if (!pages) return <p className="px-6 text-center text-sm text-white/80" data-testid="doc-viewer-loading">{t("app.loading")}</p>;

  return (
    <div className="mx-auto flex max-w-3xl flex-col items-center gap-4 px-3" data-testid="doc-viewer-frame">
      {pages.map((src, i) => (
        <img key={i} src={src} alt={`${title || "doc"} ${i + 1}`} draggable={false} className="w-full select-none rounded-lg bg-white shadow-lg" />
      ))}
    </div>
  );
};
